// extracted by mini-css-extract-plugin
module.exports =  {"root":"_32bbee5fda--root--Vd86P","label":"_32bbee5fda--label--iSWAG"};